import {
  type IConfigurationCardEntry,
  type IConfigurationCardTreeEntry,
} from '../ConfigurationCardContext.tsx';

/**
 * Converte la lista flat di entry in un albero,
 * raggruppando le sub-card sotto la card genitore.
 */
export function buildEntryTree(
  entries: IConfigurationCardEntry[],
): IConfigurationCardTreeEntry[] {
  const topLevel: IConfigurationCardTreeEntry[] = [];
  const childrenMap = new Map<string, IConfigurationCardTreeEntry[]>();

  for (const entry of entries) {
    const treeEntry: IConfigurationCardTreeEntry = {
      id: entry.id,
      title: entry.title,
    };

    if (entry.parentId) {
      const siblings = childrenMap.get(entry.parentId) ?? [];
      siblings.push(treeEntry);
      childrenMap.set(entry.parentId, siblings);
    } else {
      topLevel.push(treeEntry);
    }
  }

  return topLevel.map(entry => ({
    ...entry,
    children: childrenMap.get(entry.id),
  }));
}
